import React from "react";
import { Panel, Row, Col, FormGroup, } from "react-bootstrap";
import { Label, ActionButton, DownloadFileLink } from "fw/components";
import * as Modals from 'fw/globals/Modals'
import API from 'fw/system/API';
import * as APIModules from "modules/app/API";
import * as Formatting from "fw/misc/Formatting";
import { EmailStatusLabel } from 'areas/shared/controls';
import { EmailStatusCode } from 'areas/shared/consts';
import * as Notifications from 'fw/globals/Notifications';
import Loading from 'layouts/public/loading/Loading'

class EmailInfoComp extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

    initialState = () => {
        return {
			loading: true,
			form: {}
		};
    }

	componentDidMount() {
		// If email info was passed as prop, set form directly
		if (this.props.emailInfo != null)
			this.setState({ 
				loading: false,
				form: this.props.emailInfo
			});
		// Otherwise go get the info with the emailKey
		else
        	this.get();
    }

	get = () => {
        var rq = {
            emailKey: this.props.emailKey
        };

        new API().get(APIModules.Emailing.url('/Emails/Retrieve'), rq,
            {
                success: (r) => {
                    // Store search results
                    this.setState({ 
						loading: false,
                        form: r.data
					});
                },
				error: r => {
                    Notifications.error(r.error.errorMessage);
					this.setState({ loading: false });
                }
            }); 
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    };

    _processResend=()=>{
        // Resend request
        var rq={
            emailKey: this.props.emailKey
        };

        APIModules.Emailing.post('/Emails/Resend', rq,
        {
            success: (r) => {
				Notifications.success(r.message);
            },
            error: (r) => {
				Notifications.error(r.error.errorMessage);
            }
        });
    }

    _handleResend = () => { 
        // Only trigger resend if we receive confirmation
        Modals.confirm( 
            "This action will resend a copy of this e-mail to all it's recipients<br/>Are you sure you want to proceed?", 
            this._processResend
            );
    };
    
    _renderEmailInfo() {
        var styleLabel = { minWidth: '20%' };
        var styleFormGroup = { marginBottom: '10px' };
        
        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <FormGroup style={styleFormGroup}>
                            <Label style={styleLabel}>Sender:</Label>
                            <span>{this.state.form.sender}</span>
                        </FormGroup>
                        <FormGroup style={styleFormGroup}>
                            <Label style={styleLabel}>Recipient:</Label>
                            <span>
                                {this.state.form.recipientsName ?
                                    <React.Fragment>
                                        {this.state.form.recipientsName}&nbsp;
                                    </React.Fragment>
                                : null}
                                &lt;{this.state.form.recipients}&gt;
                                {this.state.form.recipientsTypeDescription ?
                                    <React.Fragment>
                                        &nbsp;({this.state.form.recipientsTypeDescription})
                                    </React.Fragment>
                                : null}
                            </span>
                        </FormGroup>
                        <FormGroup style={styleFormGroup}>
                            <Label style={styleLabel}>Company:</Label>
                            {this.state.form.companyName ?
                                <span>{this.state.form.companyName}</span>
                            : <span> - </span> }
                        </FormGroup>
                        <FormGroup style={styleFormGroup}>
                            <Label style={styleLabel}>CC:</Label>
                            <span>{this.state.form.cc}</span>
                        </FormGroup>
						<FormGroup style={styleFormGroup}>
							<Label style={styleLabel}>BCC:</Label>
							<span>{this.state.form.bcc}</span>
						</FormGroup> 
                    </Col>
                    <Col md={6}>
                    <FormGroup style={styleFormGroup}>
                        <Label style={styleLabel}>Date:</Label>
                        <span>
                            {Formatting.formatClientDateTime(this.state.form.createDate)}
                        </span>
                    </FormGroup>
                    <FormGroup style={styleFormGroup}>
                        <Label style={styleLabel}>Status:</Label>
                        <EmailStatusLabel emailStatusCode={this.state.form.emailStatusCode}/>                        
                    </FormGroup>
					<FormGroup style={styleFormGroup}>
                        <Label style={styleLabel}>Clicked:</Label>
                        <span>
                            {Formatting.formatClientDateTime(this.state.form.clickedDate)}
                        </span>                        
                    </FormGroup>
					<FormGroup style={styleFormGroup}>
                        <Label style={styleLabel}>Opened:</Label>
                        <span>
                            {Formatting.formatClientDateTime(this.state.form.openedDate)}
                        </span>                       
                    </FormGroup>
                    <FormGroup style={styleFormGroup}>
                        <Label style={styleLabel}>Category:</Label>
                        {this.state.form.emailCategory ?
                            <span class="badge badge-secondary">{this.state.form.emailCategory}</span>
                        : <span> - </span> }
                    </FormGroup>
                </Col>
                </Row>
            </React.Fragment>
        );
    }

    _renderEmailError() {
        var errorMsg = this.state.form.log || "(Error description is empty)";
        
        var styleErrDiv = {
            fontWeight: "bold",
            fontStyle: "italic",
            color: "red",
            borderStyle: "dotted",
            borderWidth: "1px",
            borderColor: "grey",
            backgroundColor: "#ffe4e1"
        };

        return (           
            <pre style={styleErrDiv}>Delivery error!<br/>{errorMsg}</pre>
        );
    }

    _renderEmailActions() {                
        return (
                <div className="pull-right">
                    <ActionButton 
                        id="btnEmailResend" 
                        onClick={this._handleResend} 
                        icon="repeat"
                        disabled={EmailStatusCode.QUEUED === this.state.form.emailStatusCode}>
                            Re-send Email
                    </ActionButton>
                </div>
        );
    }

    _renderEmailBody() {        
        var styleBodyDiv = {
                borderStyle: "groove",
                borderWidth: "3px",
                borderColor: "#dcdcdc", 
                borderRadius: "5px",
                minHeight: "200px",
                maxHeight: "500px",
                overflow: "auto"
            };

        return (                
                <div
                    style={styleBodyDiv}
                    dangerouslySetInnerHTML={{ __html: this.state.form.body }}>
                </div>
        );
    }

    _renderEmailAttach() {
        var files= this.state.form.attachs.map( (f) => {
                return(
                    <div style={{padding: '4px'}}>
                        <DownloadFileLink
                            storageToken={f.storageKey}
                            buttonName={f.attachmentName} 
                            fileName={f.attachmentName} />
                    </div>
                );
            });

        return (
            <React.Fragment>
                <Label>Attached files:</Label>
                {files}                
            </React.Fragment>
        );
    }

    render() {
		if (this.state.loading)
			return <Loading />

        return (
            <React.Fragment>
                <Panel>
                    <Panel.Body>
                        <Row>
                            <Col md={10}>
                                {this._renderEmailInfo()}
                            </Col>
                            <Col md={2}>
                                {this._renderEmailActions()}
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label style={{minWidth:'10%'}}>Subject:</Label>
                                    <span>{this.state.form.subject}</span>
                                </FormGroup>
                            </Col>
                        </Row>
                        {this.state.form.emailStatusCode === "ERROR" &&
                        <Row>
                            <Col md={12}>
                                {this._renderEmailError()}
                            </Col>
                        </Row>}
                        <hr/>
                        <Row>
                            <Col md={12}>
                                {this._renderEmailBody()}
                            </Col>
                        </Row>
                        {this.state.form.attachs.length > 0 &&
                        <Row>
                            <Col md={12}>
                                {this._renderEmailAttach()}
                            </Col>
                        </Row>
                        }
                    </Panel.Body>
                </Panel>
            </React.Fragment>
        );
    }
}

export default EmailInfoComp;



// WEBPACK FOOTER //
// ./src/areas/admin/emailingLog/emailInfo/EmailInfoComp.js